import {
    ColumnDef,
    getReceiptColumns,
} from 'components/contracts-page-wrapper/contracts-page-wrapper-helper';
import { TabItemsType } from 'components/landing-page-wrapper/components/TabComponent';
import { toLocalDateTimeString } from 'lib';

export const tableHeight: number = 270;
export const highResTableHeight: number = 290;
export const receiptsTableHeight: number = 265;
export const highResReceiptsTableHeight: number = 285;

export type SmartContractTabsType = 'Contracts' | 'Receipts';

export const SmartContractTabItems: TabItemsType[] = [
    { label: 'Contracts' },
    { label: 'Receipts' },
];

export const getColumns = (
    selectedTab: SmartContractTabsType,
    userWallets: any[],
    systemWallets: any[]
): ColumnDef[] => {
    let columns = {
        Contracts: [
            {
                field: 'name',
                headerName: 'Name',
                flex: 1,
            },
            {
                field: 'description',
                headerName: 'Description',
                flex: 1.5,
            },
            {
                field: 'timestamp',
                headerName: 'Last Modified',
                flex: 1,
                renderCell: (params: any): any => {
                    return toLocalDateTimeString(params.value, true);
                },
            },
        ],
        Receipts: getReceiptColumns(true, userWallets, systemWallets),
    };

    return columns[selectedTab];
};
